import { AgentAction, AgentTranscriptEntry } from '../../types/agentHarness';

/**
 * Folds a harness action record into the transcript. Only the verification
 * states matter: `outcome_unknown` opens a review card, a verified record
 * retires its card, and a verified record with no open card is history.
 */
export const applyActionReview = (
	entries: AgentTranscriptEntry[],
	action: AgentAction
): AgentTranscriptEntry[] => {
	const verified = action.state === 'confirmed_applied' || action.state === 'confirmed_not_applied';
	if (action.state !== 'outcome_unknown' && !verified) {
		return entries;
	}
	const index = entries.findIndex(
		(existing) => existing.kind === 'action_review' && existing.id === action.id
	);
	if (index === -1) {
		if (verified) {
			return entries;
		}
		return [
			...entries,
			{
				kind: 'action_review',
				id: action.id,
				toolName: action.toolName,
				createdAt: action.createdAt,
				state: action.state,
			},
		];
	}
	const existing = entries[index];
	// Only an open card moves, and only to a verified state: a replayed event
	// must not reopen a review that was already answered.
	if (existing.kind !== 'action_review' || existing.state !== 'outcome_unknown' || !verified) {
		return entries;
	}
	const next = entries.slice();
	next[index] = { ...existing, state: action.state };
	return next;
};
